import { ApiModel } from '@composable-api/api.model'

interface Attributes {
    [ThirdPartiesPostcodeEuDetailModel.ATTR_CITY]: string
    [ThirdPartiesPostcodeEuDetailModel.ATTR_COUNTRY]: string
    [ThirdPartiesPostcodeEuDetailModel.ATTR_NUMBER]: string
    [ThirdPartiesPostcodeEuDetailModel.ATTR_POST_CODE]: string
    [ThirdPartiesPostcodeEuDetailModel.ATTR_STREET]: string
}

export class ThirdPartiesPostcodeEuDetailModel extends ApiModel<Attributes> {
    static key = 'ThirdPartiesPostcodeEuDetailModel'

    static readonly ATTR_CITY = 'city'
    static readonly ATTR_COUNTRY = 'country'
    static readonly ATTR_NUMBER = 'number'
    static readonly ATTR_POST_CODE = 'post_code'
    static readonly ATTR_STREET = 'street'

    get city() {
        return this._getAttribute(ThirdPartiesPostcodeEuDetailModel.ATTR_CITY)
    }
    get country() {
        return this._getAttribute(ThirdPartiesPostcodeEuDetailModel.ATTR_COUNTRY)
    }
    get number() {
        return this._getAttribute(ThirdPartiesPostcodeEuDetailModel.ATTR_NUMBER)
    }
    get postCode() {
        return this._getAttribute(ThirdPartiesPostcodeEuDetailModel.ATTR_POST_CODE)
    }
    get street() {
        return this._getAttribute(ThirdPartiesPostcodeEuDetailModel.ATTR_STREET)
    }
}
